import axios from 'axios'
import router from '../router'
import api from '../api/apiConfig'
import moment from 'moment'
export default {
  namespaced: true,
  state: {
    current: {},
    currentList: [],
    OAuthCredential: null,
    signupData: null,
    authenticated: false
  },
  getters: {
    isCreatorInCurrentProject (state, getters, rootState) {
      if (rootState.project.currentProjectMember) return rootState.project.currentProjectMember.type === rootState.enumData.memberType.creator.value
    },
    isManagerInCurrentProject (state, getters, rootState) {
      if (rootState.project.currentProjectMember) return rootState.project.currentProjectMember.type === rootState.enumData.memberType.manager.value
    }
  },
  mutations: {
    setCurrent (state, current) {
      state.current = current
    },
    setCurrentList (state, currentList) {
      state.currentList = currentList
    },
    setOAuthCredential (state, credential) {
      state.OAuthCredential = credential
    },
    setSignupData (state, signupData) {
      state.signupData = signupData
    },
    setAuthenticated (state, authentication) {
      state.authenticated = authentication
    }
  },
  actions: {
    async login ({commit, state, dispatch}, condition) {
      const result = await api.login(condition)
      await dispatch('authentication')
      return result
    },
    async logout ({commit}) {
      try {
        await api.logout()
        commit('setCurrent', null)
        commit('setOAuthCredential', null)
        return true
      } catch (error) {
        switch (error.status) {
          case 401:
            return true
          case 500:
            return false
          default:
            return false
        }
      }
    },
    async authentication ({commit}) {
      try {
        let result = await api.authentication()

        commit('setCurrent', result)
        return {status: true, data: result}
      } catch (error) {
        if (error.status === 401) {
          return { status: false }
        }
      }
    },
    async getUser ({state}, id) {
      return (await axios.get(`user/${id}`)).data
    },
    async getUsersByProjectAndSubscriber ({state, rootState}, username) {
      if (!(rootState.project.current && rootState.project.current.creator && rootState.project.current.creator.user)) throw new Error('cannot get creator')

      return (await axios.get(`/subscriber/${rootState.user.current._id}/users?${username ? `name=${username}&` : ''}markProjectId=${rootState.project.current._id}`)).data
    },
    async updateMe ({state, commit, dispatch}, user) {
      await api.updateMe(user)
    },
    async add ({ state, commit, dispatch, rootState }, newUser) {
      const result = await axios.post('/user', { ...newUser, belongTo: rootState.project.current._id })
      if (result.status !== 201) {
        throw new Error('新增失敗！')
      }
    },
    getBidList ({state}) {
      return api.getBidList()
    },
    async whoAmI ({state, commit}, projectId) {
      const memberInProject = await api.getIdentityInProject(projectId)
      return memberInProject.member
    },
    async getGoogle ({ state }, credential) {
      return (
        await axios.get('/auth/google', {
          headers: { Authorization: `Bearer ${credential}` }
        })
      ).data
    },
    async loginByGoogle ({ state, commit, dispatch }) {
      await axios.post('/auth/login/google', null, {
        headers: { Authorization: `Bearer ${state.OAuthCredential}` }
      })

      const authentication = await dispatch('authentication')

      if (state.current.isSubscriber) {
        const expiredDiff = moment(state.current.subscription.expiredAt).diff(new Date(), 'day')
        if (state.current.subscription.isExpired) return alert('您已過期，請聯絡廠商')
        else if (expiredDiff > 0 && expiredDiff < 30) alert(`您即將在${expiredDiff}天後過期`)
      }

      if (router.history.current.query.redirect) {
        if (authentication.data.isRoot) {
          alert('系統管理者不應該接受邀請，為您跳轉到管理頁面')
          router.push({ name: 'RootSetting' }).catch(() => {})
        } else {
          router.push({ path: router.history.current.query.redirect }).catch(() => {})
        }
      } else {
        if (authentication.data.isRoot) {
          setTimeout(() => {
            router.push({ name: 'RootSetting' }).catch(() => {})
          }, 500)
        } else {
          setTimeout(() => {
            router.push({ name: 'Projects' }).catch(() => {})
          }, 500)
        }
      }
    },
    async connectToGoogle ({state}, googleData) {
      try {
        await axios.patch('/user/to/google', googleData)
      } catch (error) {
        if (error.status === 409) {
          alert('綁定失敗，此 Google 帳號已綁定其他帳號')
        } else {
          throw new Error('connect to google Filed:' + error.status)
        }
      }
    },
    async signupByGoogle ({state}, signupData) {
      await axios.post('public/signup', signupData)
    },
    async disConnectToGoogle ({state}) {
      await axios.patch('/user/remove/google')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js